import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EntityService } from '../../services/entity.service';
import { NotificationService } from '../../services/notification.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-contract-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgbModule],
  templateUrl: './contract-modal.component.html',
  styleUrls: ['./contract-modal.component.scss']
})
export class ContractModalComponent implements OnInit {
  @Input() starId!: string;
  @Input() isEdit = false;
  @Input() userId!: string;
  @Input() contract: any = null;
  @Output() contractUpdated = new EventEmitter<void>();

  contractForm: FormGroup;
  selectedFile: File | null = null;
  isLoading = false;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private entityService: EntityService,
    private notificationService: NotificationService
  ) {
    this.contractForm = this.fb.group({
      cle_repartition: ['', [Validators.required, Validators.min(0), Validators.max(100)]]
    });
  }

  ngOnInit() {
    if (this.isEdit && this.contract) {
      this.contractForm.patchValue({
        cle_repartition: this.contract.cle_repartition
      });
    }
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }

  onSubmit() {
    if (this.contractForm.valid) {
      this.isLoading = true;
      const formData = new FormData();
  
      // Ajouter star_id
      formData.append('star_id', this.userId);
  
      // Ajouter cle_repartition
      formData.append('cle_repartition', this.contractForm.get('cle_repartition')?.value);
  
      // Ajouter le fichier si un fichier a été sélectionné
      if (this.selectedFile) {
        formData.append('file_url', this.selectedFile);
      }
  
      if (this.isEdit) {
        // Pour la modification
        this.entityService.updateDataWithPostWithoutHeaders('/update-contrat', this.contract.id, formData).subscribe({
          next: (response) => {
            this.notificationService.success('Contrat modifié avec succès');
            this.contractUpdated.emit();
            this.activeModal.close(response);
          },
          error: (error) => {
            this.notificationService.error('Une erreur est survenue lors de la modification du contrat');
            this.isLoading = false;
            console.log(error);
          }
        });
      } else {
        // Pour la création
        this.entityService.justSaveWithoutHeaders('/contrats', formData).subscribe({
          next: (response) => {
            this.notificationService.success('Contrat ajouté avec succès');
            this.contractUpdated.emit();
            this.activeModal.close(response);
          },
          error: (error) => {
            this.notificationService.error('Une erreur est survenue lors de la création du contrat');
            this.isLoading = false;
          }
        });
      }
    }
  }
  
} 